export default __webpack_public_path__ + "static/media/raspou-ganhou.4752a397.svg";